import { Component, OnInit } from '@angular/core';
import { ProfileComponent } from '../../pages/profile/profile.component';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Essentials, MsgType } from '../../util/essentials';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  constructor(protected ref: NbDialogRef<ProfileComponent>, private essentials: Essentials,
    private translate: TranslateService) { }

  private showPassword = false;
  private password: string = '';
  private confirmPassword: string = '';

  private passwords: {
    password: string,
    confirmPassword: string
  } = {
    password: '',
    confirmPassword: ''
  }

  ngOnInit(): void {
  }

  addPasswords() {
    if (this.password == "" || this.confirmPassword == ""){
      this.essentials.showMessage(this.translate.instant("EDIT_PASSWORD.PAGE.FILL_FIELDS"), MsgType.Warning, "", "unlock-outline");
      return;

    }else if(this.password.length < 6 || this.confirmPassword.length < 6){
      this.essentials.showMessage(this.translate.instant("EDIT_PASSWORD.PAGE.MINIMUM_CHARS"), MsgType.Warning, "", "unlock-outline");
      return;

    }else if(this.password != this.confirmPassword){
      this.essentials.showMessage(this.translate.instant("EDIT_PASSWORD.PAGE.PASSWORDS_MUST_MATCH"), MsgType.Warning, "", "unlock-outline");
      return;
    }
    
    this.passwords.password = this.password;
    this.passwords.confirmPassword = this.confirmPassword;

    console.log(this.passwords);
    this.ref.close(this.passwords);
  };

  close() {
    this.ref.close();
  };

  getInputType() {
    if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

}
